"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageType = void 0;
exports.PackageType = {
    PALLETS: 'PALLETS',
    CARTONS: 'CARTONS'
};
//# sourceMappingURL=package-type.js.map